/* Hero Products — quantity stepper + buy now
   Progressive enhancement: the form still works without this file,
   it just lands on the cart page instead of checkout. */

(function () {
  'use strict';

  function clamp(value, min, max) {
    if (isNaN(value)) return min;
    if (value < min) return min;
    if (max && value > max) return max;
    return value;
  }

  function syncStepperState(input) {
    var wrap = input.closest('.hp-qty');
    if (!wrap) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 0;
    var val = parseInt(input.value, 10) || min;
    var minus = wrap.querySelector('[data-hp-step="-1"]');
    var plus = wrap.querySelector('[data-hp-step="1"]');
    if (minus) minus.disabled = val <= min;
    if (plus) plus.disabled = max > 0 && val >= max;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hp-step]');
    if (!button) return;

    var wrap = button.closest('.hp-qty');
    var input = wrap && wrap.querySelector('[data-hp-qty]');
    if (!input) return;

    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 0;
    var step = parseInt(button.getAttribute('data-hp-step'), 10) || 1;
    input.value = clamp((parseInt(input.value, 10) || min) + step, min, max);
    syncStepperState(input);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-hp-qty]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 0;
    input.value = clamp(parseInt(input.value, 10), min, max);
    syncStepperState(input);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-hp-form]');
    if (!form) return;

    event.preventDefault();

    var submitter = event.submitter || form.querySelector('[data-hp-submit="checkout"]');
    var intent = submitter ? submitter.getAttribute('data-hp-submit') : 'checkout';
    var idField = form.querySelector('input[name="id"]');
    var qtyField = form.querySelector('[data-hp-qty]');
    var errorBox = form.querySelector('[data-hp-error]');
    var buttons = form.querySelectorAll('button[type="submit"]');
    var i;

    if (!idField) return;

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    for (i = 0; i < buttons.length; i++) buttons[i].disabled = true;
    form.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(idField.value, 10),
          quantity: parseInt(qtyField ? qtyField.value : 1, 10) || 1
        }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        window.location.href = intent === 'add' ? '/cart' : '/checkout';
      })
      .catch(function (error) {
        form.classList.remove('is-loading');
        for (var j = 0; j < buttons.length; j++) buttons[j].disabled = false;
        var message = (error && (error.description || error.message)) ||
          'Sorry, that could not be added right now. Please try again.';
        if (errorBox) {
          errorBox.textContent = message;
          errorBox.hidden = false;
        }
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var inputs = document.querySelectorAll('[data-hp-qty]');
    for (var i = 0; i < inputs.length; i++) syncStepperState(inputs[i]);
  });
})();
